import { User } from '@typings';
import { useTranslation } from 'react-i18next';

import { Input } from '../various/Fields/Input';
import { FieldWrapper, FormGrid } from '../various/Form';
interface Props {
  user: User | Empty.Object;
}

export const UserInfo = ({ user }: Props) => {
  const { t } = useTranslation(['common', 'accounts']);

  return (
    <section className="box flex flex-col gap-5">
      <h3 className="heading-3">{t('accounts:account_information')}</h3>
      <p className="text-neutral-40 body-2">{t('accounts:account_information_subtitle')}</p>
      <FormGrid rowGap="medium">
        <FieldWrapper label={t('common:full_name')}>
          <Input value={user.name} isReadonly />
        </FieldWrapper>
        <FieldWrapper label={t('common:email')}>
          <Input value={user.email} isReadonly />
        </FieldWrapper>
      </FormGrid>
    </section>
  );
};
